<template>
  <div class="home flex-grow flex flex-col">
    <section class="text-center relative flex-grow flex flex-col justify-between">
      <div class="w-full mb-4">
        <h1 class="text-4xl text-gray-800 pt-6 mb-4 font-bold">{{ $t('Cart') }}</h1>
        <div
          v-for="(item, index) in itemsFiltered"
          :key="index"
          class="bg-white mx-3 my-6 rounded-lg shadow-lg flex justify-between px-4 py-6 text-lg"
        >
          <div class="flex items-center mr-3 text-left">
            <eva-icon
              name="trash-outline"
              animation="pulse"
              width="30"
              height="30"
              fill="#c53030"
              class="mr-4"
              @click="handleRemoveItem(index)"
            ></eva-icon>
            <p>{{ item[0] }}</p>
          </div>
          <div class="flex items-center">
            <p class="bg-app-orange w-10 text-white px-3 py-1 rounded-lg">{{ item[1].quantity }}</p>
            <p class="font-bold mx-1">x</p>
            <p class="bg-indigo-600 text-white px-3 py-1 rounded-lg">${{ item[1].price.toFixed(2) }}</p>
            <p class="font-bold mx-1">=</p>
            <p class="bg-app-green text-white px-3 py-1 rounded-lg">
              ${{ (item[1].quantity * item[1].price).toFixed(2) }}
            </p>
          </div>
        </div>

        <div class="bg-white mx-3 my-6 rounded-lg shadow-lg flex justify-between px-4 py-6 text-lg">
          <div class="flex items-center">
            <eva-icon
              name="shopping-cart-outline"
              animation="pulse"
              width="35"
              height="35"
              fill="#384E77"
              class="mr-4"
            ></eva-icon>
            <p class="font-bold text-xl">{{ $t('Total') }}</p>
          </div>
          <p class="font-bold text-xl">$ {{ cartTotal.toFixed(2) }}</p>
        </div>
      </div>
      <input class="form-input h-16 mx-4 rounded-lg mb-8" :placeholder="$t('Notes on your order')" v-model="note" />
      <div class="flex justify-center items-center mb-4">
        <p class="mr-4 text-xl">{{ $t('Please select your table') }}:</p>
        <select v-model="table" class="form-select ml-4 h-16 w-24 px-4 py-4">
          <option value=""></option>
          <option v-for="(table, index) in tables" :value="table.name" :key="index">{{ table.name }}</option>
        </select>
      </div>
      <div class="flex">
        <button
          class="mx-auto mt-6 mb-6 rounded-full bg-red-600 text-center px-4 py-2 font-light text-white flex items-center"
          @click="handleGoToMenu"
        >
          <eva-icon
            name="corner-up-left-outline"
            animation="pulse"
            width="20"
            height="20"
            fill="#FFFFFF"
            class="mr-2"
          ></eva-icon>
          {{ $t('Menu') }}
        </button>
        <button
          class="mx-auto mt-6 mb-6 rounded-full bg-blue-600 text-center px-4 py-3 font-light text-white"
          @click="handleGoMyOrders"
        >
          {{ $t('My Orders') }}
        </button>
        <button
          class="mx-auto mt-6 mb-6 rounded-full bg-green-400 text-center px-10 py-3 font-light text-white"
          @click="handlePlaceOrder"
        >
          {{ $t('Place Order') }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { db, auth } from '@/firebase';

export default {
  name: 'Cart',
  async created() {
    if (this.items.length === 0) {
      const latestCart = localStorage.getItem('latestCart');
      this.$store.commit('setCart', JSON.parse(latestCart));
    } else {
      localStorage.setItem('latestCart', JSON.stringify(this.items));
    }
    const lTable = localStorage.getItem('latestTable');
    if (lTable) {
      this.table = lTable;
    }
    const { restaurant: restaurantId } = this.items[0];
    const restaurant = await db
      .collection('restaurants')
      .doc(restaurantId)
      .get();
    if (restaurant.exists) {
      this.restaurant = restaurant.data();
    }
  },
  data() {
    return {
      restaurant: null,
      table: '',
      note: '',
    };
  },
  computed: {
    items() {
      return this.$store.getters.cart;
    },
    itemsFiltered() {
      const d = {};
      this.items.forEach(i => {
        const { name, price } = i;
        if (d[name]) {
          d[name].quantity += 1;
        } else {
          d[name] = { quantity: 1, price };
        }
      });

      return Object.entries(d);
    },
    cartTotal() {
      return this.items.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0);
    },
    tables() {
      return this.restaurant ? this.restaurant.tables : [];
    },
  },
  methods: {
    handleRemoveItem(index) {
      this.$store.commit('removeFromCartWithIndex', index);
      localStorage.setItem('latestCart', JSON.stringify(this.items));
    },
    async handlePlaceOrder() {
      if (this.table === '') {
        this.$toasted.error(this.$t('Please select your table'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
        return;
      }
      if (this.items.length > 0) {
        const { restaurant } = this.items[0];
        const { uid } = auth.currentUser;
        const newOrder = {
          items: this.items,
          orderTime: new Date(),
          status: 'pending',
          customer: uid,
          table: this.table,
          note: this.note,
        };
        try {
          const { id } = await db.collection(`restaurants/${restaurant}/orders`).add(newOrder);
          this.$toasted.success(this.$t('Order created!'), {
            theme: 'bubble',
            position: 'top-center',
            duration: 3000,
          });
          this.$store.commit('clearCart');
          localStorage.setItem('latestCart', JSON.stringify(this.items));
          localStorage.setItem('latestTable', this.table);
          this.$store.commit('addToOrders', { ...newOrder, id, restaurant });
          this.$router.push(`/order/${id}`);
        } catch (e) {
          console.log('e :', e);
        }
      }
    },
    handleGoToMenu() {
      let restaurantId;
      if (this.items.length > 0) {
        restaurantId = this.items[0].restaurant;
      } else {
        restaurantId = localStorage.getItem('lastRestaurant');
      }

      this.$router.push(`/restaurants/${restaurantId}`);
    },
    handleGoMyOrders() {
      this.$router.push('/myorders');
    },
  },
};
</script>
<style lang="scss"></style>
